import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AuditLog {
  id: string;
  timestamp: string;
  level: 'success' | 'error' | 'warn' | 'info';
  action: string;
  resource: string;
  userId?: string;
  userEmail?: string;
  details?: Record<string, unknown>;
}

export interface PaginatedLogs {
  items: AuditLog[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
  links: {
    first: string;
    previous: string;
    next: string;
    last: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  constructor(private readonly http: HttpClient) {}

  getLogs(
    page: number = 1,
    limit: number = 50,
    search?: string,
    level?: string
  ): Observable<PaginatedLogs> {
    let params = new HttpParams().set('page', page).set('limit', limit);

    if (search) {
      params = params.set('search', search);
    }
    if (level) {
      params = params.set('level', level);
    }

    return this.http.get<PaginatedLogs>(
      `${environment.backendUrl}/v0/audit/logs`,
      {
        params,
      }
    );
  }
}
